import { render, staticRenderFns } from "./LocalizationToggle.vue?vue&type=template&id=576a1a47&"
import script from "./LocalizationToggle.vue?vue&type=script&lang=js&"
export * from "./LocalizationToggle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports